import { UPDATE_USER_FAILURE, UPDATE_USER_REQUEST, UPDATE_USER_RESET, UPDATE_USER_SUCCESS } from "../../types/user";


const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
};

const updateUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER_REQUEST:
      return {
        loading: true,
        message: "",
        error: "",
        success: false,
      };
    case UPDATE_USER_SUCCESS:
      return {
        loading: false,
        message: action.payload.message || "Records updated successfully",
        error: "",
        success: true,
      };
    case UPDATE_USER_FAILURE:
      return {
        loading: false,
        message: "",
        error: action.error || "Records update failed",
        success: false,
      };
    case UPDATE_USER_RESET:
      return initialState;
    default:
      return state;
  }
};

export default updateUserReducer;
